import socketIOClient from "socket.io-client";
import { toast } from "react-toastify";

const WS =
  process.env.NODE_ENV === "production"
    ? location.origin
    : "http://localhost:8080";

let socket = null;

export const initSocket = (authToken = null) => {
  const options = {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
    query: { token: authToken || token },
  };
  socket = socketIOClient(`${WS}/main`, options);

  socket.on("connect_error", (e) => {
    toast.error(
      "Impossible de se connecter au Socket. L'app ne fonctionnera pas correctement"
    );
  });
  return socket;
};

export const closeSocket = () => {
  socket.close();
  socket = null;
};

export default () => {
  if (socket) {
    return socket;
  } else {
    const token = localStorage.getItem("casa_token");
    return initSocket(token);
  }
};
